let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fz3OS")).then(() => parcelRequire('dWu3Q'));